export default Object.freeze({
    none: 'none',
    single: 'single',
    multiple: 'multiple',
})
